import { render, staticRenderFns } from "./TimelineReview.vue?vue&type=template&id=264d1a6c&scoped=true&"
import script from "./TimelineReview.vue?vue&type=script&lang=js&"
export * from "./TimelineReview.vue?vue&type=script&lang=js&"
import style0 from "./TimelineReview.vue?vue&type=style&index=0&id=264d1a6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d1a6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
